import React from 'react'
import { Snackbar, SnackbarContent } from '@material-ui/core'
export default function ErrorMessage({ open, setOpen, message }) {
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={open}
            onClose={() => setOpen(false)}
            autoHideDuration={3000}
        >
            <SnackbarContent style={{ backgroundColor: "red", }}
                message={message}  >

            </SnackbarContent>
        </Snackbar>
    )
}
